import { Component, Input, OnInit } from "@angular/core";
import { EFItineraryContent, EFPOI, EFProduct } from '../../../models/experience.model';
import { LocalizationService } from '../../../services/localization.service';

@Component({
    selector: 'app-ef-product-location',
    templateUrl: './ef-product-location.component.html',
    styleUrls: ['./ef-product-location.component.scss'],
    standalone: false
})
export class EfProductLocationComponent implements OnInit {

    @Input() productData:EFProduct|EFItineraryContent;
    @Input() POIData:EFPOI;

    constructor(private localizationService:LocalizationService) { }

    ngOnInit(): void {}

    getTranslatedValue(object:any, field:string) {
        if(object.translations != null) {
            if('length' in object.translations) {
                for(let _translation of object.translations) {
                    if(_translation.language == this.localizationService.currentLanguage) {
                        if(_translation[field] != null && _translation[field] != '') return _translation[field];
                        else break;
                    }
                }
            }
            else {
                for(let i in object.translations) {
                    if(i == this.localizationService.currentLanguage) {
                        let _translation = object.translations[i];
                        if(_translation[field] != null && _translation[field] != '') return _translation[field];
                        else break;
                    }
                }
            }
        }

        return object[field];
    }

    getProductLocationName() {
        if(this.POIData != null) {
            return this.getTranslatedValue(this.POIData, 'name')
        }
    }

    formatProductLocation() {
        let _retVal = '';

        let _product = this.POIData != null ? this.POIData : this.productData;
        
        if(_product) {
            if(_product instanceof EFProduct) {
                if(_product.locality != null && _product.locality != _product.city) {
                    _retVal += _product.locality;
                }

                if(_product.city != null) {
                    if(_retVal != '') _retVal += ', '
                    _retVal += _product.city;
                }

                if(_product.province != null) {
                    if(_retVal != '') _retVal += ' '
                    _retVal += '(' + _product.province + ')';
                }
        
                if(_product.address != null) {
                    if(_retVal != '') _retVal += ', '
                    _retVal += _product.address;
                }
            }
            else {
                _retVal = this.localizationService.translate('pg-map-link.title')
            }

        }

        return _retVal
    }

    getProductCoordinates() {
        let _result = null;

        let _product = this.POIData != null ? this.POIData : this.productData;

        if(_product?.geolocation != null) {
            _result = _product.geolocation.coordinates[0] + ',' + _product.geolocation.coordinates[1]
        }

        return _result;
    }

    getProductLocationDescription() {
        if(this.productData != null && 'getTranslatedProductField' in this.productData) {
            return this.productData.getTranslatedProductField('location_description')
        }
    }
}